import React, { useEffect, useRef } from 'react';
import './Btnbook.css';

const Btnbook = ({ onBookNow }) => {
    const btnRef = useRef(null);

    useEffect(() => {
        // Add animation when component mounts
        const btn = btnRef.current;
        if (btn) {
            setTimeout(() => {
                btn.classList.add('visible');
            }, 1000);
        }
    }, []);

    return (
        <div className="btnbook" ref={btnRef}>
            <button
                onClick={onBookNow}
                aria-label="Book Now"
                className="book-now-btn"
            >
                <span className="btn-text">Book Now</span>
                <span className="btn-icon">→</span>
            </button>
        </div>
    );
};

export default Btnbook;
